const performDelete = {
  methods: {
    getStatus() {
    },
    async performDelete(id, idField = 'id') {
      this.loading = true;
      if (this.deleteMultiple) {
        const results = await this.$apiCall(`mutation performDelete($ids: [ID]!) {
                                                objectsDelete(ids:$ids) {id, error}
                                              }`,
                                            {ids:this.selected.map(obj => obj[idField])});
        this.loading = false;
        if (!results.error) {
          this.showDelete = false;
          const errorCount = results.data.objectsDelete.length;
          this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                          message:`Deleted ${this.selected.length - errorCount} of ${this.selected.length}\
                                                   ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
          if (idField !== 'id')
            results.data.objectsDelete.forEach(obj => obj.id = this.selected.find(s => s[idField] === obj.id).id);
          this.$refs.table?.buildList(results.data.objectsDelete);
        }
      }

      else {
        const results = await this.$apiCall(`mutation performDelete($id: ID!) {
                                                objectDelete(id:$id)
                                              }`,
                                            {id});
        this.loading = false;
        if (!results.error) {
          this.showDelete = false;
          this.$refs.table?.buildList();
          this.$store.commit('setError', {type:'success',message:`Delete successful`});
        }
      }

      this.getStatus();
    }
  }
}

export default performDelete